/*
 * @Author: jingyu.yang 
 * @Date: 2021-12-17 09:54:14 
 * @Last Modified by: jingyu.yang
 * @Last Modified time: 2021-12-17 09:59:09
 */
import {
  post,
  getJson
} from '../http';

/**
 * @function startPlay
 * @description 播放/暂停/恢复播放/停止
 * @param {string} meetingId 房间id
 * @param {object} p 
 * @returns {Promise}
 */
export const startPlay = (meetingId, p) => post(config.incurt + `/liveondemandinfos/${meetingId}`, p);

/**
 * @function getDetail
 * @description 获取插播信息
 * @param {string} meetingId 房间id
 * @returns {Promise}
 */
export const getDetail = (meetingId) => getJson(config.incurt + `/liveondemandinfos/${meetingId}?query=recordinfo`)

/**
 * @function getPseDetail
 * @description 获取伪直播播放信息
 * @param {string} meetingId 房间id
 * @returns {Promise}
 */
export const getPseDetail = (meetingId) => getJson(config.incurt + `/vlsinfos/${meetingId}?query=recordinfo`)
